import React from "react";
// arco
import { Typography, Space } from '@arco-design/web-react';

// utils
import { fCurrency } from "src/utils/format-number";
import { useAuthContext } from "src/auth/hooks";

// ----------------------------------------------------------------------

export default function BalanceDisplay() {
    const { user } = useAuthContext();
    const { balance } = user || {};

    const color = (balance && balance < 0) ? '#ff4d4f' : 'inherit';

    return (
        <Space align="center">
            <Typography.Text>账户余额:</Typography.Text>
            <Typography.Text style={{ color }}>{ fCurrency(balance) }</Typography.Text>
        </Space>
    );
}
